export default "__VITE_ASSET__Davq_aig__"